import { AverageTypes, TaxTypes } from "../enums";
import { averageLabels } from "../lang";
import type { Dataset, Year } from "../types";

interface GetIncreaseOptions {
  data?: Dataset["tax"];
  years: Year[];
  tax: TaxTypes;
}

export function getIncrease({
  data,
  years,
  tax,
}: GetIncreaseOptions): number | null {
  if (!data) {
    return null;
  }

  const startData = data.get(years.at(0));
  const endData = data.get(years.at(-1));

  if (!startData || !endData) {
    return null;
  }

  const startTax = startData[tax];
  const endTax = endData[tax];

  if (!startTax || !endTax) {
    return null;
  }

  return endTax / startTax - 1;
}

interface GetIncreaseLabelOptions {
  increase: number;
  increaseStateAverage: number;
  increaseTotalAverage: number;
}

export function getIncreaseNote({
  increase,
  increaseStateAverage,
  increaseTotalAverage,
}: GetIncreaseLabelOptions): string {
  if (increase <= increaseStateAverage && increase <= increaseTotalAverage) {
    return averageLabels[AverageTypes.SMALLER_OR_EQUAL];
  }

  if (
    increase >= increaseStateAverage * 1.1 &&
    increase >= increaseTotalAverage * 1.1
  ) {
    return averageLabels[AverageTypes.LARGER_ABOVE_10];
  }

  return averageLabels[AverageTypes.LARGER_BELOW_10];
}
